/**
 * @prettier
 */

import createBehavior from '@js/functions/createBehavior.js';
import axios from 'axios';

const VivenuAvailabilityBehavior = createBehavior(
  'vivenu-availability',
  {
    checkAvailability() {
      if (this.eventId) {
        this.node.classList.remove('is-availability-error');
        this.node.classList.add('is-availability-loading');
        axios({
          method: 'GET',
          url: `/api/v1/online-sales/vivenu/events/${this.eventId}/availability`,
        })
          .then((res) => {
            this.node.classList.remove('is-availability-loading');
            this.node.classList.toggle('is-full', res.data.is_full);
            this.node.classList.toggle('is-available', res.data.is_available && !res.data.is_full);
            if (this.btn) {
              if (res.data.is_available && !res.data.is_full) {
                this.btn.removeAttribute('inert');
              } else {
                this.btn.setAttribute('inert', '');
              }
            }
          })
          .catch((err) => {
            this.node.classList.remove('is-availability-loading');
            this.node.classList.add('is-availability-error');
          });
      }
    },
  },
  {
    init() {
      this.eventId = this.options['event-id'];
      this.btn = this.node.querySelector('[data-product-id]');

      if (!this.eventId) {
        console.error(
          'vivenu-availability behavior was not passed a event-id',
        );
      }

      if (this.btn) {
        this.btn.setAttribute('inert', '');
      }

      // Make sure axios global settings are set from cart behavior
      setTimeout(() => {
        this.checkAvailability();
      }, 0);
    },
    destroy() {},
  },
);

export default VivenuAvailabilityBehavior;
